/**
 * The currencies the system accepts, in one place.
 *
 * Before this list existed the set was written out four times on the frontend
 * and nowhere at all on the backend: every gateway DTO took a bare `@IsString()`
 * on its currency field, so `POST /rent` happily persisted any string — an
 * arbitrary value supplied by an Avito import included.
 *
 * The list lives here rather than in `@rentflowdev/api` because the gateway and
 * auth-service both validate against it, and neither should depend on a
 * client-facing types package to know what a currency is.
 */
export const SUPPORTED_CURRENCIES = ["RUB", "USD", "EUR"];
/** What a landlord gets before they choose anything. */
export const DEFAULT_CURRENCY = "RUB";
export function isSupportedCurrency(value) {
    return (value != null && SUPPORTED_CURRENCIES.includes(value));
}
